import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import TAGGED from './modules/tagged_content'

const [ w, d, l, content ] = [ window, document, location, location.pathname.replace(/^\/([^/]+)\//,'$1') ]

const detail_init = async the_id => {

}

const init = () => {


}


TAGGED({ 
  perpage: 24,
  related: true,
  itemTemplate: `
    <div id="main" class="column-3-4">
      <transition-group class="${content}-list" tag="div" name="fade" mode="out-in" :class="[ 'is-paged-' + paged ]">
        <a class="${content}-item" :href="article.href" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
          <figure class="${content}-item__img">
            <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
              <img :src="article.thumb" width="200">
            </div>
            <span class="cate" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span>
          </figure>
          <div class="${content}-item__body">
            <span class="cate" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span>
            <span class="subject">
              {{ article.title }}
              <span class="new" v-if="article.is_new">NEW</span>
            </span>
            <span class="desc">{{ article.desc }}</span>
            <div class="tags" v-if="article.keywords != null">
              <span class="tag" v-for="tag in article.keywords">#{{tag}}</span>
            </div>
          </div>
        </a>
      </transition-group>
      <pagination
        v-if="totalPage > 1"
        :paged="paged"
        :total-page="totalPage"
        :total-item="totalItem"
        :item-count="pagedArticles.length"
        :prevText="'Prev'"
        :nextText="'Next'"
        @change="pageChange"
      />
    </div>
  `,
  callback(){}
})

$(() => {
  init()
  if( w.query_string('article') ) detail_init( w.query_string('article') )
})